export const MultiDocument = () => (
  <>
    <path
      d='M5.89474 20.5706H5C4.44772 20.5706 4 20.1229 4 19.5706V4.42773C4 3.87545 4.44772 3.42773 5 3.42773H15C15.5523 3.42773 16 3.87545 16 4.42773V4.57059'
      stroke='currentColor'
      fill='none'
    />
    <path
      d='M2.89474 18.1429H2C1.44772 18.1429 1 17.6951 1 17.1429V2C1 1.44771 1.44772 1 2 1H12C12.5523 1 13 1.44772 13 2V2.14286'
      stroke='currentColor'
      fill='none'
    />
    <path
      d='M16.9167 6H8C7.44772 6 7 6.44772 7 7V22C7 22.5523 7.44772 23 8 23H20C20.5523 23 21 22.5523 21 22V11.1M16.9167 6L21 11.1M16.9167 6V11.1H21'
      stroke='currentColor'
      fill='none'
    />
  </>
)
